/** @jsxRuntime classic */
/** @jsx jsx */
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import LogoutPopup from './Modal/LogoutPopup'
import { jsx } from "@emotion/core";
import LogoutIcon from './LogoutIcon';
import { setAddQuickLinkClick } from '../../redux/slices/SettingSclice';
// import { setAddQuickLinkClick } from '../../redux/slices/CardSlice';

function Logout({ activeTab, setActiveTab }) {
  const dispatch=useDispatch()
  const [logoutPopup, setLogoutPopup] = useState(false)
  const {colorPicker, colorPickerDark, theme} = useSelector(state => state.theme)
  const [onMouseEnterLogout,setOnMouseEnterLogout]=useState(false)
 
  return (
    <>
      <li className={`li-setting-tab logout ${activeTab == "logout" ? 'active' : ''}`}
      
      css={{
       '&:hover .accordion-title':{
        color:((theme == "dark" && colorPickerDark == "#ef233c")) ? "white !important" : (theme == "dark" && colorPickerDark == "#f8961e") ? "black !important" : (theme == "dark" && colorPickerDark == "#ffca3a") ? "black !important" : (theme == "dark" && colorPickerDark == "#27cb9a") ? "black !important" : (theme == "dark" && colorPickerDark == "#4cc9f0") ? "black !important" : "white !important"
       }
      }}
      onClick={() => {setLogoutPopup(true) ;dispatch(setAddQuickLinkClick(false)); dispatch(setAddQuickLinkClick(false))}}>
        <div className="settings-accordion-tab" 
         style={{background:theme == "dark" ? "black" :""}}
         css={{
          background: activeTab == "logout" ? (theme == 'dark' ? `linear-gradient(0deg,var(--accent-color-10),var(--accent-color-10)),#000 !important` : `linear-gradient(0deg, var(--accent-color), var(--accent-color)), #ffffff !important`) : 
          'transparent',
          '&:hover':{
           background: theme == 'dark' ? `linear-gradient(0deg, var(--accent-color-10), var(--accent-color-10)), #000 !important` : `linear-gradient(0deg, var(--accent-color), var(--accent-color)), #ffffff !important`
         }
       }}>
          <div className="settings-accordion-heading">
            <figure className="settings-icon">
              {
                activeTab == "logout" 
                ?
                 <img src="images/new-log-out.svg" className="img-default dark:invert-color" /> 
                 : 
                 <img src="images/new-log-out.svg" className="img-default dark:invert-color" /> 
              }
            </figure>
            <h3 className="accordion-title uppercase dark:text-white">Logout</h3>
          </div>
        </div>
      </li>
      {
        logoutPopup && (
          <LogoutPopup
            show={logoutPopup}
            onHide={() => setLogoutPopup(false)}
          />
        )
      }
    </>
  )
}

export default Logout